// src/data/albums.static.js

// normalize for tolerant matching (lowercase, strip diacritics, drop punctuation)
const normForKey = (s = "") =>
  String(s)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .replace(/[\p{P}\p{S}]/gu, " ") // punctuation & symbols (incl curly quotes)
    .replace(/\s+/g, " ")
    .trim();

export const albumKey = (title, year) =>
  `${normForKey(title)}|${Number(year) || ""}`;

/* -------------------------------------------------------------
     Shared objects (so multiple title aliases point to same data)
  -------------------------------------------------------------- */

// Pat Garrett & Billy The Kid — 1973
const PAT_GARRETT_1973 = {
  artist: "Bob Dylan",
  album: "Pat Garrett & Billy The Kid (Soundtrack From The Motion Picture)",
  year: 1973,
  tracks: [
    ["Main Title Theme (Billy)", "6:02"],
    ["Cantina Theme (Workin' for the Law)", "2:53"],
    ["Billy 1", "3:52"],
    ["Bunkhouse Theme", "2:12"],
    ["River Theme", "1:27"],
    ["Turkey Chase", "3:31"],
    ["Knockin' On Heaven's Door", "2:29"],
    ["Final Theme", "5:21"],
    ["Billy 4", "4:59"],
    ["Billy 7", "2:07"],
  ],
};

// Before The Flood (Live) — 1974
const BEFORE_THE_FLOOD_1974 = {
  artist: "Bob Dylan, The Band",
  album: "Before The Flood (Live)",
  year: 1974,
  tracks: [
    // Disc 1
    ["Most Likely You Go Your Way (And I'll Go Mine)", "4:16"],
    ["Lay, Lady, Lay", "3:17"],
    ["Rainy Day Women #12 & 35", "3:24"],
    ["Knockin' on Heaven's Door", "3:52"],
    ["It Ain't Me, Babe", "3:41"],
    ["Ballad of a Thin Man", "4:05"],
    ["Up on Cripple Creek", "5:29"],
    ["I Shall Be Released", "3:51"],
    ["Endless Highway", "5:10"],
    ["The Night They Drove Old Dixie Down", "4:25"],
    ["Stage Fright", "4:46"],
    // Disc 2
    ["Don't Think Twice, It's All Right", "4:36"],
    ["Just Like a Woman", "5:05"],
    ["It's Alright, Ma (I'm Only Bleeding)", "5:47"],
    ["The Shape I'm In", "4:02"],
    ["When You Awake", "3:13"],
    ["The Weight", "4:55"],
    ["All Along the Watchtower", "3:23"],
    ["Highway 61 Revisited", "4:27"],
    ["Like a Rolling Stone", "7:09"],
    ["Blowin' in the Wind", "4:37"],
  ],
};

// Planet Waves — 1974
const PLANET_WAVES_1974 = {
  artist: "Bob Dylan",
  album: "Planet Waves",
  year: 1974,
  tracks: [
    ["On a Night Like This", "2:57"],
    ["Going, Going, Gone", "3:27"],
    ["Tough Mama", "4:17"],
    ["Hazel", "2:49"],
    ["Something There Is About You", "4:45"],
    ["Forever Young - Slow Version", "4:57"],
    ["Forever Young - Fast Version", "2:48"],
    ["Dirge", "5:36"],
    ["You Angel You", "2:53"],
    ["Never Say Goodbye", "2:54"],
    ["Wedding Song", "4:42"],
  ],
};

// The Basement Tapes — 1975
const BASEMENT_TAPES_1975 = {
  artist: "Bob Dylan, The Band",
  album: "The Basement Tapes",
  year: 1975,
  tracks: [
    // Disc 1
    ["Odds and Ends", "1:46"],
    ["Orange Juice Blues", "3:39"],
    ["Million Dollar Bash", "2:32"],
    ["Yazoo Street Scandal", "3:29"],
    ["Goin' to Acapulco", "5:27"],
    ["Katie's Been Gone", "2:48"],
    ["Lo and Behold!", "2:46"],
    ["Bessie Smith", "4:18"],
    ["Clothes Line Saga", "2:58"],
    ["Apple Suckling Tree", "2:48"],
    ["Please, Mrs. Henry", "2:33"],
    ["Tears of Rage", "4:16"],
    // Disc 2
    ["Too Much of Nothing", "3:03"],
    ["Yea! Heavy And A Bottle Of Bread", "2:15"],
    ["Ain't No More Cane", "3:58"],
    ["Crash on the Levee", "2:04"],
    ["Ruben Remus", "3:16"],
    ["Tiny Montgomery", "2:50"],
    ["You Ain't Goin' Nowhere", "2:43"],
    ["Don't Ya Tell Henry", "3:13"],
    ["Nothing Was Delivered", "4:23"],
    ["Open the Door, Homer", "2:49"],
    ["Long Distance Operator", "3:39"],
    ["This Wheel's On Fire", "3:49"],
  ],
};

// Blood On The Tracks — 1975
const BLOOD_ON_THE_TRACKS_1975 = {
  artist: "Bob Dylan",
  album: "Blood On The Tracks",
  year: 1975,
  tracks: [
    ["Tangled up in Blue", "5:40"],
    ["Simple Twist of Fate", "4:17"],
    ["You're a Big Girl Now", "4:34"],
    ["Idiot Wind", "7:47"],
    ["You're Gonna Make Me Lonesome When You Go", "2:55"],
    ["Meet Me in the Morning", "4:21"],
    ["Lily, Rosemary and the Jack of Hearts", "8:52"],
    ["If You See Her, Say Hello", "4:47"],
    ["Shelter from the Storm", "5:00"],
    ["Buckets of Rain", "3:22"],
  ],
};

// Hard Rain (Live) — 1976
const HARD_RAIN_1976 = {
  artist: "Bob Dylan",
  album: "Hard Rain (Live)",
  year: 1976,
  tracks: [
    ["Maggie's Farm", "5:35"],
    ["One Too Many Mornings", "3:42"],
    ["Stuck Inside of Mobile with the Memphis Blues Again", "6:34"],
    ["Oh, Sister", "4:35"],
    ["Lay, Lady, Lay", "4:53"],
    ["Shelter from the Storm", "5:25"],
    ["You're a Big Girl Now", "6:56"],
    ["I Threw It All Away", "3:24"],
    ["Idiot Wind", "10:06"],
  ],
};

// Desire — 1976
const DESIRE_1976 = {
  artist: "Bob Dylan",
  album: "Desire",
  year: 1976,
  tracks: [
    ["Hurricane", "8:32"],
    ["Isis", "6:59"],
    ["Mozambique", "3:01"],
    ["One More Cup of Coffee", "3:46"],
    ["Oh, Sister", "4:03"],
    ["Joey", "11:05"],
    ["Romance in Durango", "5:43"],
    ["Black Diamond Bay", "7:30"],
    ["Sara", "5:31"],
  ],
};

// Street-Legal — 1978
const STREET_LEGAL_1978 = {
  artist: "Bob Dylan",
  album: "Street-Legal",
  year: 1978,
  tracks: [
    ["Changing of the Guards", "6:37"],
    ["New Pony", "4:29"],
    ["No Time to Think", "8:20"],
    ["Baby, Stop Crying", "5:18"],
    ["Is Your Love in Vain?", "4:31"],
    ["Señor (Tales of Yankee Power)", "5:39"],
    ["True Love Tends to Forget", "4:15"],
    ["We Better Talk This Over", "4:05"],
    ["Where Are You Tonight? (Journey Through Dark Heat)", "6:15"],
  ],
};

// Slow Train Coming — 1979
const SLOW_TRAIN_COMING_1979 = {
  artist: "Bob Dylan",
  album: "Slow Train Coming",
  year: 1979,
  tracks: [
    ["Gotta Serve Somebody", "5:25"],
    ["Precious Angel", "6:31"],
    ["I Believe in You", "5:10"],
    ["Slow Train", "5:59"],
    ["Gonna Change My Way of Thinking", "5:28"],
    ["Do Right to Me Baby (Do Unto Others)", "3:53"],
    ["When You Gonna Wake Up", "5:30"],
    ["Man Gave Names to All the Animals", "4:27"],
    ["When He Returns", "4:26"],
  ],
};

// Bob Dylan At Budokan (Live) — 1979
const AT_BUDOKAN_1979 = {
  artist: "Bob Dylan",
  album: "Bob Dylan At Budokan (Live)",
  year: 1979,
  tracks: [
    // Disc 1
    ["Mr. Tambourine Man", "5:05"],
    ["Shelter from the Storm", "4:39"],
    ["Love Minus Zero, No Limit", "3:57"],
    ["Ballad of a Thin Man", "4:53"],
    ["Don't Think Twice, It's All Right", "5:08"],
    ["Maggie's Farm", "5:26"],
    ["One More Cup of Coffee (Valley Below)", "3:30"],
    ["Like a Rolling Stone", "6:37"],
    ["I Shall Be Released", "4:24"],
    ["Is Your Love in Vain?", "4:02"],
    ["Going, Going, Gone", "4:26"],
    // Disc 2
    ["Blowin' in the Wind", "4:33"],
    ["Just Like a Woman", "5:06"],
    ["Oh, Sister", "4:51"],
    ["Simple Twist of Fate", "4:27"],
    ["All Along the Watchtower", "3:26"],
    ["I Want You", "2:37"],
    ["All I Really Want to Do", "3:48"],
    ["Knockin' on Heaven's Door", "4:03"],
    ["It's Alright, Ma (I'm Only Bleeding)", "6:07"],
    ["Forever Young", "5:40"],
    ["The Times They Are A-Changin'", "5:34"],
  ],
};

// Saved — 1980
const SAVED_1980 = {
  artist: "Bob Dylan",
  album: "Saved",
  year: 1980,
  tracks: [
    ["A Satisfied Mind", "1:58"],
    ["Saved", "4:02"],
    ["Covenant Woman", "6:05"],
    ["What Can I Do for You?", "5:53"],
    ["Solid Rock", "3:58"],
    ["Pressing On", "5:14"],
    ["In the Garden", "5:59"],
    ["Saving Grace", "5:04"],
    ["Are You Ready", "4:45"],
  ],
};

// Shot of Love — 1981
const SHOT_OF_LOVE_1981 = {
  artist: "Bob Dylan",
  album: "Shot Of Love",
  year: 1981,
  tracks: [
    ["Shot of Love", "4:18"],
    ["Heart of Mine", "4:29"],
    ["Property of Jesus", "4:32"],
    ["Lenny Bruce", "4:31"],
    ["Watered-Down Love", "4:09"],
    ["The Groom's Still Waiting at the Altar", "4:02"],
    ["Dead Man, Dead Man", "3:58"],
    ["In the Summertime", "3:34"],
    ["Trouble", "4:32"],
    ["Every Grain of Sand", "6:11"],
  ],
};

// Infidels — 1983
const INFIDELS_1983 = {
  artist: "Bob Dylan",
  album: "Infidels",
  year: 1983,
  tracks: [
    ["Jokerman", "6:18"],
    ["Sweetheart Like You", "4:35"],
    ["Neighborhood Bully", "4:37"],
    ["License to Kill", "3:35"],
    ["Man of Peace", "6:31"],
    ["Union Sundown", "5:25"],
    ["I and I", "5:11"],
    ["Don't Fall Apart on Me Tonight", "5:52"],
  ],
};

// Real Live — 1984 (alias 1985 below just in case)
const REAL_LIVE_1984 = {
  artist: "Bob Dylan",
  album: "Real Live",
  year: 1984,
  tracks: [
    ["Highway 61 Revisited", "5:13"],
    ["Maggie's Farm", "4:50"],
    ["I and I", "6:17"],
    ["License to Kill", "3:31"],
    ["It Ain't Me, Babe", "5:23"],
    ["Tangled up in Blue", "7:02"],
    ["Masters of War", "6:33"],
    ["Ballad of a Thin Man", "4:16"],
    ["Girl of the North Country", "4:27"],
    ["Tombstone Blues", "4:33"],
  ],
};

// Empire Burlesque — 1985
const EMPIRE_BURLESQUE_1985 = {
  artist: "Bob Dylan",
  album: "Empire Burlesque",
  year: 1985,
  tracks: [
    ["Tight Connection to My Heart (Has Anyone Seen My Love)", "5:20"],
    ["Seeing the Real You at Last", "4:19"],
    ["I'll Remember You", "4:12"],
    ["Clean Cut Kid", "4:15"],
    ["Never Gonna Be the Same Again", "3:08"],
    ["Trust Yourself", "3:27"],
    ["Emotionally Yours", "4:28"],
    ["When the Night Comes Falling from the Sky", "7:28"],
    ["Something's Burning, Baby", "4:52"],
    ["Dark Eyes", "5:07"],
  ],
};

// Knocked Out Loaded — 1986
const KNOCKED_OUT_LOADED_1986 = {
  artist: "Bob Dylan",
  album: "Knocked Out Loaded",
  year: 1986,
  tracks: [
    ["You Wanna Ramble", "3:18"],
    ["They Killed Him", "4:03"],
    ["Driftin' Too Far from Shore", "3:40"],
    ["Precious Memories", "3:14"],
    ["Maybe Someday", "3:18"],
    ["Brownsville Girl", "11:03"],
    ["Got My Mind Made Up", "2:55"],
    ["Under Your Spell", "3:58"],
  ],
};

// Down In The Groove — 1988
const DOWN_IN_THE_GROOVE_1988 = {
  artist: "Bob Dylan",
  album: "Down In The Groove",
  year: 1988,
  tracks: [
    ["Let's Stick Together", "3:09"],
    ["When Did You Leave Heaven?", "2:14"],
    ["Sally Sue Brown", "2:29"],
    ["Death Is Not the End", "5:09"],
    ["Had a Dream About You, Baby", "2:52"],
    ["Ugliest Girl in the World", "3:30"],
    ["Silvio", "3:05"],
    ["Ninety Miles an Hour (Down a Dead End Street)", "2:55"],
    ["Shenandoah", "3:38"],
    ["Rank Strangers to Me", "2:58"],
  ],
};

// Dylan & The Dead (Live) — 1989
const DYLAN_DEAD_1989 = {
  artist: "Bob Dylan",
  album: "Dylan & The Dead (Live)",
  year: 1989,
  tracks: [
    ["Slow Train", "4:56"],
    ["I Want You", "4:04"],
    ["Gotta Serve Somebody", "5:50"],
    ["Queen Jane Approximately", "6:38"],
    ["Joey", "9:22"],
    ["All Along the Watchtower", "6:23"],
    ["Knockin' on Heaven's Door", "6:52"],
  ],
};

// Oh Mercy — 1989
const OH_MERCY_1989 = {
  artist: "Bob Dylan",
  album: "Oh Mercy",
  year: 1989,
  tracks: [
    ["Political World", "3:47"],
    ["Where Teardrops Fall", "2:32"],
    ["Everything Is Broken", "3:15"],
    ["Ring Them Bells", "3:00"],
    ["Man in the Long Black Coat", "4:32"],
    ["Most of the Time", "5:05"],
    ["What Good Am I?", "4:44"],
    ["Disease of Conceit", "3:43"],
    ["What Was It You Wanted", "5:02"],
    ["Shooting Star", "3:14"],
  ],
};

// Under The Red Sky — 1990
const UNDER_THE_RED_SKY_1990 = {
  artist: "Bob Dylan",
  album: "Under The Red Sky",
  year: 1990,
  tracks: [
    ["Wiggle Wiggle", "2:09"],
    ["Under the Red Sky", "4:09"],
    ["Unbelievable", "4:05"],
    ["Born in Time", "3:39"],
    ["T.V. Talkin' Song", "3:02"],
    ["10,000 Men", "4:22"],
    ["2 X 2", "3:36"],
    ["God Knows", "3:01"],
    ["Handy Dandy", "4:02"],
    ["Cat's in the Well", "3:21"],
  ],
};

// The Bootleg Series Volumes 1–3 — 1991
const BOOTLEG_VOL_1_3_1991 = {
  artist: "Bob Dylan",
  album: "The Bootleg Series Volumes 1-3 (Rare And Unreleased) 1961-1991",
  year: 1991,
  tracks: [
    // Volume 1
    ["Hard Times In New York Town - Demo - 1961", "2:17"],
    ["He Was a Friend of Mine - Take 2", "4:01"],
    ["Man On the Street - Studio Outtake - 1961", "1:54"],
    ["No More Auction Block - Live at the Gaslight Café", "3:01"],
    ["House Carpenter - Take 1", "4:07"],
    ["Talkin' Bear Mountain Picnic Massacre Blues - Studio Outtake", "3:43"],
    ["Let Me Die In My Footsteps - Studio Outtake - 1962", "3:32"],
    ["Rambling, Gambling Willie - Studio Outtake - 1962", "4:12"],
    ["Talkin' Hava Negeilah Blues - Studio Outtake - 1962", "0:51"],
    ["Quit Your Low Down Ways - Studio Outtake - 1962", "2:38"],
    ["Worried Blues - Studio Outtake - 1962", "2:37"],
    ["Kingsport Town - Freewheelin' Outtake", "3:27"],
    ["Walkin' Down the Line - Demo - 1963", "2:51"],
    ["Walls of Red Wing - Studio Outtake - 1963", "5:03"],
    ["Paths of Victory - Studio Outtake - 1963", "3:16"],
    ["Talkin' John Birch Paranoid Blues - Live at Carnegie Hall", "4:24"],
    ["Who Killed Davey Moore? - Live at Carnegie Hall", "3:07"],
    ["Only a Hobo - Studio Outtake - 1963", "3:28"],
    ["Moonshiner - The Times They Are A-Changin' Outtake", "5:05"],
    ["When the Ship Comes In - Witmark Demo - 1963", "2:54"],
    ["The Times They Are A-Changin' - Witmark Demo - 1963", "2:58"],
    ["Last Thoughts on Woody Guthrie - Live at Town Hall", "7:07"],
    // Volume 2
    ["Seven Curses - The Times They Are A-Changin' Outtake", "3:46"],
    ["Eternal Circle - Studio Outtake - 1963", "2:37"],
    ["Suze (The Cough Song) - Studio Outtake - 1963", "1:56"],
    ["Mama, You Been On My Mind - Studio Outtake - 1964", "2:55"],
    ["Farewell, Angelina - Studio Outtake - 1965", "5:25"],
    ["Subterranean Homesick Blues - Alternate Take", "2:53"],
    ["If You Gotta Go, Go Now - Studio Outtake - 1965", "2:54"],
    ["Sitting On a Barbed Wire Fence - Studio Outtake - 1965", "3:51"],
    ["Like a Rolling Stone - Alternate Take", "1:34"],
    [
      "It Takes a Lot to Laugh, It Takes a Train to Cry - Alternate Take",
      "3:20",
    ],
    ["I'll Keep It with Mine - Studio Outtake - 1966", "3:37"],
    ["She's Your Lover Now - Studio Outtake - 1966", "6:08"],
    ["I Shall Be Released - Alternate Take", "3:54"],
    ["Santa-Fe - Studio Outtake - 1967", "2:08"],
    ["If Not for You (Alternate Take)", "3:31"],
    ["Wallflower - Studio Outtake - 1971", "2:47"],
    ["Nobody 'Cept You - Studio Outtake - 1973", "2:39"],
    ["Tangled Up in Blue - Take 3, Remake 2", "6:50"],
    ["Call Letter Blues - Take 2", "4:27"],
    ["Idiot Wind - Take 4, Remake with organ overdub", "8:51"],
    // Volume 3
    ["If You See Her, Say Hello - Take 2", "3:44"],
    ["Golden Loom - Studio Outtake - 1975", "4:25"],
    ["Catfish - Studio Outtake - 1975", "2:48"],
    ["Seven Days - Live at the Curtis Hixon Convention Center", "3:59"],
    ["Ye Shall Be Changed - Studio Outtake - 1979", "4:07"],
    ["Every Grain of Sand - Demo - 1980", "3:36"],
    ["You Changed My Life - Studio Outtake - 1981", "5:12"],
    ["Need a Woman - Studio Outtake - 1981", "5:41"],
    ["Angelina - Studio Outtake - 1981", "6:57"],
    ["Someone's Got a Hold of My Heart - Studio Outtake", "4:31"],
    ["Tell Me - Studio Outtake - 1983", "4:23"],
    ["Lord Protect My Child - Studio Outtake - 1983", "3:56"],
    ["Foot of Pride - Studio Outtake - 1983", "5:56"],
    ["Blind Willie McTell - Studio Outtake - 1983", "5:51"],
    ["When the Night Comes Falling from the Sky - Alternate Take", "5:37"],
    ["Series of Dreams - Studio Outtake - 1989", "5:51"],
  ],
};

// Good As I Been To You — 1992
const GOOD_AS_I_BEEN_1992 = {
  artist: "Bob Dylan",
  album: "Good As I Been To You",
  year: 1992,
  tracks: [
    ["Frankie & Albert", "3:49"],
    ["Jim Jones", "3:53"],
    ["Blackjack Davey", "5:48"],
    ["Canadee-I-O", "4:21"],
    ["Sittin' on Top of the World", "4:28"],
    ["Little Maggie", "2:53"],
    ["Hard Times", "4:32"],
    ["Step It up and Go", "2:55"],
    ["Tomorrow Night", "3:41"],
    ["Arthur McBride", "6:19"],
    ["You're Gonna Quit Me", "2:46"],
    ["Diamond Joe", "3:15"],
    ["Froggie Went a Courtin'", "6:22"],
  ],
};

// World Gone Wrong — 1993
const WORLD_GONE_WRONG_1993 = {
  artist: "Bob Dylan",
  album: "World Gone Wrong",
  year: 1993,
  tracks: [
    ["World Gone Wrong", "3:54"],
    ["Love Henry", "4:22"],
    ["Ragged & Dirty", "4:07"],
    ["Blood in My Eyes", "5:02"],
    ["Broke Down Engine", "3:20"],
    ["Delia", "5:39"],
    ["Stack a Lee", "3:48"],
    ["Two Soldiers", "5:42"],
    ["Jack-a-Roe", "4:53"],
    ["Lone Pilgrim", "2:43"],
  ],
};

// MTV Unplugged (Live) — 1995
const MTV_UNPLUGGED_1995 = {
  artist: "Bob Dylan",
  album: "MTV Unplugged (Live)",
  year: 1995,
  tracks: [
    ["Tombstone Blues", "4:54"],
    ["Shooting Star", "4:05"],
    ["All Along the Watchtower", "3:36"],
    ["The Times They Are A-Changin'", "5:48"],
    ["John Brown", "5:22"],
    ["Rainy Day Women #12 & 35", "3:31"],
    ["Desolation Row", "8:22"],
    ["Dignity", "6:30"],
    ["Knockin' on Heaven's Door", "5:30"],
    ["Like a Rolling Stone", "9:09"],
    ["With God on Our Side", "7:16"],
  ],
};

// Time Out Of Mind — 1997
const TIME_OUT_OF_MIND_1997 = {
  artist: "Bob Dylan",
  album: "Time Out Of Mind",
  year: 1997,
  tracks: [
    ["Love Sick", "5:21"],
    ["Dirt Road Blues", "3:36"],
    ["Standing in the Doorway", "7:43"],
    ["Million Miles", "5:52"],
    ["Tryin' to Get to Heaven", "5:21"],
    ["'Til I Fell in Love with You", "5:17"],
    ["Not Dark Yet", "6:29"],
    ["Cold Irons Bound", "7:15"],
    ["Make You Feel My Love", "3:32"],
    ["Can't Wait", "5:47"],
    ["Highlands", "16:31"],
  ],
};

// “Love and Theft” — 2001
const LOVE_AND_THEFT_2001 = {
  artist: "Bob Dylan",
  album: "Love And Theft",
  year: 2001,
  tracks: [
    ["Tweedle Dee & Tweedle Dum", "4:46"],
    ["Mississippi", "5:21"],
    ["Summer Days", "4:53"],
    ["Bye and Bye", "3:17"],
    ["Lonesome Day Blues", "6:06"],
    ["Floater (Too Much to Ask)", "5:00"],
    ["High Water (For Charley Patton)", "4:03"],
    ["Moonlight", "3:24"],
    ["Honest with Me", "5:49"],
    ["Po' Boy", "3:08"],
    ["Cry a While", "5:04"],
    ["Sugar Baby", "6:41"],
  ],
};

// Modern Times — 2006
const MODERN_TIMES_2006 = {
  artist: "Bob Dylan",
  album: "Modern Times",
  year: 2006,
  tracks: [
    ["Thunder on the Mountain", "5:53"],
    ["Spirit on the Water", "7:41"],
    ["Rollin' and Tumblin'", "6:01"],
    ["When the Deal Goes Down", "5:04"],
    ["Someday Baby", "4:55"],
    ["Workingman's Blues #2", "6:07"],
    ["Beyond the Horizon", "5:34"],
    ["Nettie Moore", "6:52"],
    ["The Levee's Gonna Break", "5:43"],
    ["Ain't Talkin'", "8:48"],
  ],
};

// Together Through Life — 2009
const TOGETHER_THROUGH_LIFE_2009 = {
  artist: "Bob Dylan",
  album: "Together Through Life",
  year: 2009,
  tracks: [
    ["Beyond Here Lies Nothin' (Explicit)", "3:50"],
    ["Life Is Hard", "3:38"],
    ["My Wife's Home Town", "4:15"],
    ["If You Ever Go to Houston", "5:48"],
    ["Forgetful Heart", "3:41"],
    ["Jolene", "3:50"],
    ["This Dream of You", "5:50"],
    ["Shake Shake Mama", "3:36"],
    ["I Feel a Change Comin' On", "5:25"],
    ["It's All Good", "5:27"],
  ],
};

// Christmas In The Heart — 2009
const CHRISTMAS_IN_THE_HEART_2009 = {
  artist: "Bob Dylan",
  album: "Christmas In The Heart",
  year: 2009,
  tracks: [
    ["Here Comes Santa Claus", "2:35"],
    ["Do You Hear What I Hear?", "3:02"],
    ["Winter Wonderland", "1:52"],
    ["Hark the Herald Angels Sing", "2:30"],
    ["I'll Be Home for Christmas", "2:54"],
    ["Little Drummer Boy", "2:52"],
    ["The Christmas Blues", "2:54"],
    ["O' Come All Ye Faithful (Adeste Fideles)", "2:48"],
    ["Have Yourself a Merry Little Christmas", "4:05"],
    ["Must Be Santa", "2:48"],
    ["Silver Bells", "2:35"],
    ["The First Noel", "2:30"],
    ["Christmas Island", "2:27"],
    ["The Christmas Song", "3:56"],
    ["O' Little Town of Bethlehem", "2:17"],
  ],
};

// Tempest — 2012
const TEMPEST_2012 = {
  artist: "Bob Dylan",
  album: "Tempest",
  year: 2012,
  tracks: [
    ["Duquesne Whistle", "5:43"],
    ["Soon After Midnight", "3:27"],
    ["Narrow Way", "7:28"],
    ["Long and Wasted Years", "3:46"],
    ["Pay in Blood", "5:09"],
    ["Scarlet Town", "7:17"],
    ["Early Roman Kings", "5:14"],
    ["Tin Angel", "9:05"],
    ["Tempest", "13:54"],
    ["Roll on John", "7:25"],
  ],
};

// Shadows in the Night — 2015
const SHADOWS_IN_THE_NIGHT_2015 = {
  artist: "Bob Dylan",
  album: "Shadows in the Night",
  year: 2015,
  tracks: [
    ["I'm A Fool To Want You", "4:51"],
    ["The Night We Called It A Day", "3:24"],
    ["Stay with Me", "2:56"],
    ["Autumn Leaves", "3:01"],
    ["Why Try to Change Me Now", "3:37"],
    ["Some Enchanted Evening", "3:28"],
    ["Full Moon and Empty Arms", "3:26"],
    ["Where Are You?", "3:37"],
    ["What'll I Do", "3:20"],
    ["That Lucky Old Sun", "3:36"],
  ],
};

// Fallen Angels — 2016
const FALLEN_ANGELS_2016 = {
  artist: "Bob Dylan",
  album: "Fallen Angels",
  year: 2016,
  tracks: [
    ["Young At Heart", "2:59"],
    ["Maybe You'll Be There", "2:56"],
    ["Polka Dots And Moonbeams", "3:35"],
    ["All The Way", "4:01"],
    ["Skylark", "2:56"],
    ["Nevertheless", "3:27"],
    ["All or Nothing at All", "3:04"],
    ["On a Little Street in Singapore", "2:16"],
    ["It Had to be You", "4:02"],
    ["Melancholy Mood", "2:53"],
    ["That Old Black Magic", "3:02"],
    ["Come Rain or Come Shine", "2:39"],
  ],
};

// Rolling Thunder Revue Sampler — 2019
const ROLLING_THUNDER_SAMPLER_2019 = {
  artist: "Bob Dylan",
  album: "The Rolling Thunder Revue: The 1975 Live Recordings (Sampler)",
  year: 2019,
  tracks: [
    ["Tonight I'll be Staying Here With You", "2:59"],
    ["If You See Her, Say Hello", "2:56"],
    ["Easy and Slow", "5:23"],
    ["A Hard Rain's A-Gonna Fall", "5:12"],
    ["It Ain't Me, Babe", "5:06"],
    ["The Lonesome Death of Hattie Carroll", "5:17"],
    ["I Dreamed I Saw St. Augustine", "2:57"],
    ["Isis", "5:14"],
    ["Romance In Durango", "4:36"],
    ["Hurricane", "8:00"],
  ],
};

// Triplicate — 2017 (3 discs, 30 tracks)
const TRIPLICATE_2017 = {
  artist: "Bob Dylan",
  album: "Triplicate",
  year: 2017,
  tracks: [
    // Disc 1
    ["I Guess I'll Have to Change My Plans", "2:26"],
    ["September of My Years", "3:25"],
    ["I Could Have Told You", "3:39"],
    ["Once Upon a Time", "3:37"],
    ["Stormy Weather", "3:05"],
    ["This Nearly Was Mine", "2:48"],
    ["That Old Feeling", "3:38"],
    ["It Gets Lonely Early", "3:10"],
    ["My One and Only Love", "3:23"],
    ["Trade Winds", "2:36"],
    // Disc 2
    ["Braggin'", "2:44"],
    ["As Time Goes By", "3:22"],
    ["Imagination", "2:34"],
    ["How Deep is the Ocean", "3:23"],
    ["P.S. I Love You", "4:17"],
    ["The Best Is Yet to Come", "2:57"],
    ["But Beautiful", "3:22"],
    ["Here's That Rainy Day", "3:27"],
    ["Where Is the One", "3:14"],
    ["There's a Flaw in My Flue", "2:41"],
    // Disc 3
    ["Day In, Day Out", "3:01"],
    ["I Couldn't Sleep a Wink Last Night", "3:15"],
    ["Sentimental Journey", "3:11"],
    ["Somewhere Along the Way", "3:18"],
    ["When the World Was Young", "3:47"],
    ["These Foolish Things", "4:11"],
    ["You Go to My Head", "3:06"],
    ["Stardust", "2:34"],
    ["It's Funny to Everyone but Me", "2:38"],
    ["Why Was I Born", "2:49"],
  ],
};

// Rough and Rowdy Ways — 2020
const ROUGH_AND_ROWDY_2020 = {
  artist: "Bob Dylan",
  album: "Rough and Rowdy Ways",
  year: 2020,
  tracks: [
    ["I Contain Multitudes", "4:36"],
    ["False Prophet", "6:00"],
    ["My Own Version of You", "6:41"],
    ["I've Made Up My Mind to Give Myself to You", "6:32"],
    ["Black Rider", "4:12"],
    ["Goodbye Jimmy Reed", "4:13"],
    ["Mother of Muses", "4:29"],
    ["Crossing the Rubicon", "7:22"],
    ["Key West (Philosopher Pirate)", "9:34"],
    ["Murder Most Foul", "16:54"],
  ],
};

// Shadow Kingdom — 2023
const SHADOW_KINGDOM_2023 = {
  artist: "Bob Dylan",
  album: "Shadow Kingdom",
  year: 2023,
  tracks: [
    ["When I Paint My Masterpiece", "4:25"],
    ["Most Likely You Go Your Way (And I'll Go Mine)", "3:32"],
    ["Queen Jane Approximately", "5:14"],
    ["I'll Be Your Baby Tonight", "3:04"],
    ["Just Like Tom Thumb's Blues", "4:26"],
    ["Tombstone Blues", "5:00"],
    ["To Be Alone with You", "3:10"],
    ["What Was It You Wanted", "5:03"],
    ["Forever Young", "3:15"],
    ["Pledging My Time", "3:50"],
    ["The Wicked Messenger", "2:56"],
    ["Watching the River Flow", "3:00"],
    ["It's All Over Now, Baby Blue", "2:49"],
    ["Sierra's Theme", "4:23"],
  ],
};

// The Complete Budokan 1978 (Live) — 2023
const COMPLETE_BUDOKAN_1978_2023 = {
  artist: "Bob Dylan",
  album: "The Complete Budokan 1978 (Live)",
  year: 2023,
  tracks: [
    // Disc 1
    ["A Hard Rain's A-Gonna Fall", "4:32"],
    ["Repossession Blues", "2:49"],
    ["Mr. Tambourine Man", "5:26"],
    ["I Threw It All Away", "5:25"],
    ["Shelter from the Storm", "4:44"],
    ["Love Minus Zero / No Limit", "4:16"],
    ["Girl from the North Country", "5:02"],
    ["Ballad of a Thin Man", "4:44"],
    ["Maggie's Farm", "5:04"],
    ["To Ramona", "4:40"],
    ["Like a Rolling Stone", "6:33"],
    ["I Shall Be Released", "4:28"],
    ["Is Your Love in Vain?", "5:00"],
    ["Going, Going, Gone", "4:03"],
    // Disc 2
    ["One of Us Must Know (Sooner or Later)", "4:32"],
    ["Blowin' in the Wind", "4:31"],
    ["Just Like a Woman", "5:02"],
    ["Oh, Sister", "4:40"],
    ["Simple Twist of Fate", "4:16"],
    ["You're a Big Girl Now", "5:32"],
    ["All Along the Watchtower", "4:13"],
    ["I Want You", "2:31"],
    ["All I Really Want to Do", "3:57"],
    ["Tomorrow Is a Long Time", "4:23"],
    ["Don't Think Twice, It's All Right", "5:08"],
    ["Band Introductions", "2:40"],
    ["It's Alright, Ma (I'm Only Bleeding)", "6:34"],
    ["Forever Young", "7:18"],
    ["The Times They Are A-Changin'", "5:02"],
    // Disc 3
    ["A Hard Rain's A-Gonna Fall", "4:05"],
    ["Love Her With A Feeling", "2:52"],
    ["Mr. Tambourine Man", "5:04"],
    ["I Threw It All Away", "5:17"],
    ["Love Minus Zero / No Limit", "4:05"],
    ["Shelter from the Storm", "4:51"],
    ["Girl from the North Country", "4:17"],
    ["Ballad of a Thin Man", "4:48"],
    ["Maggie's Farm", "5:31"],
    ["One More Cup of Coffee (Valley Below)", "3:28"],
    ["Like a Rolling Stone", "6:50"],
    ["I Shall Be Released", "4:23"],
    ["Is Your Love in Vain?", "4:14"],
    ["Going, Going, Gone", "4:04"],
    // Disc 4
    ["One of Us Must Know (Sooner or Later)", "4:44"],
    ["Blowin' in the Wind", "4:35"],
    ["Just Like a Woman", "5:06"],
    ["Oh, Sister", "4:57"],
    ["I Don't Believe You (She Acts Like We Never Have Met)", "4:23"],
    ["You're a Big Girl Now", "4:58"],
    ["All Along the Watchtower", "3:27"],
    ["I Want You", "2:43"],
    ["All I Really Want to Do", "3:49"],
    ["Knockin' On Heaven's Door", "4:09"],
    ["The Man in Me", "3:51"],
    ["Band Introductions", "1:56"],
    ["It's Alright, Ma (I'm Only Bleeding)", "6:39"],
    ["Forever Young", "7:50"],
    ["The Times They Are A-Changin'", "5:11"],
  ],
};

// The 1974 Live Recordings Sampler — 2024
const LIVE_1974_SAMPLER_2024 = {
  artist: "Bob Dylan",
  album: "The 1974 Live Recordings Sampler",
  year: 2024,
  tracks: [
    ["Most Likely You Go Your Way (And I'll Go Mine)", "3:29"],
    ["Just Like Tom Thumb's Blues", "5:28"],
    ["Mr. Tambourine Man", "4:18"],
    ["Something There Is About You", "4:21"],
    ["Love Minus Zero / No Limit", "3:15"],
    ["She Belongs to Me", "2:43"],
    ["Wedding Song", "3:04"],
    ["Nobody 'Cept You", "2:55"],
    ["It Ain't Me, Babe", "3:31"],
    ["Ballad of Hollis Brown", "3:38"],
    ["The Lonesome Death of Hattie Carroll", "5:08"],
    ["The Times They Are A-Changin'", "3:28"],
    ["Gates of Eden", "5:09"],
    ["It's All Over Now, Baby Blue", "4:26"],
    ["Maggie's Farm", "4:43"],
    ["All Along the Watchtower", "2:35"],
    ["Highway 61 Revisited", "3:59"],
    ["Like a Rolling Stone", "5:44"],
    ["Forever Young", "5:07"],
    ["Blowin' in the Wind", "4:22"],
  ],
};

/* -------------------------------------------------------------
     Early albums (constants for aliases)
  -------------------------------------------------------------- */

// Bob Dylan — 1962
const BOB_DYLAN_1962 = {
  artist: "Bob Dylan",
  album: "Bob Dylan",
  year: 1962,
  tracks: [
    ["You're No Good", "1:42"],
    ["Talkin' New York", "3:21"],
    ["In My Time of Dyin'", "2:41"],
    ["Man of Constant Sorrow", "3:10"],
    ["Fixin' to Die", "2:23"],
    ["Pretty Peggy-O", "3:26"],
    ["Highway 51 Blues", "2:52"],
    ["Gospel Plow", "1:47"],
    ["Baby, Let Me Follow You Down", "2:37"],
    ["House of the Risin' Sun", "5:21"],
    ["Freight Train Blues", "2:21"],
    ["Song to Woody", "2:45"],
    ["See That My Grave Is Kept Clean", "2:42"],
  ],
};

// The Freewheelin’ Bob Dylan — 1963
const FREEWHEELIN_1963 = {
  artist: "Bob Dylan",
  album: "The Freewheelin' Bob Dylan",
  year: 1963,
  tracks: [
    ["Blowin' in the Wind", "2:48"],
    ["Girl from the North Country", "3:23"],
    ["Masters of War", "4:38"],
    ["Down the Highway", "3:32"],
    ["Bob Dylan's Blues", "2:28"],
    ["A Hard Rain's A-Gonna Fall", "6:52"],
    ["Don't Think Twice, It's All Right", "3:40"],
    ["Bob Dylan's Dream", "5:02"],
    ["Oxford Town", "1:50"],
    ["Talkin' World War III Blues", "6:27"],
    ["Corrina, Corrina", "2:44"],
    ["Honey, Just Allow Me One More Chance", "2:00"],
    ["I Shall Be Free", "4:46"],
  ],
};

// Another Side Of Bob Dylan — 1964 (shared for aliases)
const ANOTHER_SIDE_1964 = {
  artist: "Bob Dylan",
  album: "Another Side Of Bob Dylan",
  year: 1964,
  tracks: [
    ["All I Really Want to Do", "4:04"],
    ["Black Crow Blues", "3:13"],
    ["Spanish Harlem Incident", "2:25"],
    ["Chimes of Freedom", "7:09"],
    ["I Shall Be Free No. 10", "4:47"],
    ["To Ramona", "3:52"],
    ["Motorpsycho Nightmare", "4:33"],
    ["My Back Pages", "4:24"],
    ["I Don't Believe You (She Acts Like We Never Have Met)", "4:23"],
    ["Ballad in Plain D", "8:18"],
    ["It Ain't Me Babe", "3:32"],
  ],
};

// The Times They Are A-Changin' — 1964
const TIMES_1964 = {
  artist: "Bob Dylan",
  album: "The Times They Are A-Changin'",
  year: 1964,
  tracks: [
    ["The Times They Are A-Changin'", "3:17"],
    ["Ballad of Hollis Brown", "5:07"],
    ["With God on Our Side", "7:09"],
    ["One Too Many Mornings", "2:42"],
    ["North Country Blues", "4:36"],
    ["Only a Pawn in Their Game", "3:32"],
    ["Boots of Spanish Leather", "4:40"],
    ["When the Ship Comes In", "3:18"],
    ["The Lonesome Death of Hattie Carroll", "5:48"],
    ["Restless Farewell", "5:32"],
  ],
};

// Highway 61 Revisited — 1965
const HIGHWAY61_1965 = {
  artist: "Bob Dylan",
  album: "Highway 61 Revisited",
  year: 1965,
  tracks: [
    ["Like a Rolling Stone", "6:11"],
    ["Tombstone Blues", "6:00"],
    ["It Takes a Lot to Laugh, It Takes a Train to Cry", "4:09"],
    ["From a Buick 6", "3:19"],
    ["Ballad of a Thin Man", "5:57"],
    ["Queen Jane Approximately", "5:31"],
    ["Highway 61 Revisited", "3:30"],
    ["Just Like Tom Thumb's Blues", "5:31"],
    ["Desolation Row", "11:19"],
  ],
};

// Bringing It All Back Home — 1965
const BRINGING_IT_ALL_BACK_HOME_1965 = {
  artist: "Bob Dylan",
  album: "Bringing It All Back Home",
  year: 1965,
  tracks: [
    ["Subterranean Homesick Blues", "2:19"],
    ["She Belongs to Me", "2:49"],
    ["Maggie's Farm", "3:59"],
    ["Love Minus Zero", "2:50"],
    ["Outlaw Blues", "3:03"],
    ["On the Road Again", "2:34"],
    ["Bob Dylan's 115th Dream", "6:31"],
    ["Mr. Tambourine Man", "5:26"],
    ["Gates of Eden", "5:42"],
    ["It's Alright, Ma (I'm Only Bleeding)", "7:31"],
    ["It's All Over Now, Baby Blue", "4:13"],
  ],
};

// Blonde On Blonde — 1966
const BLONDE_ON_BLONDE_1966 = {
  artist: "Bob Dylan",
  album: "Blonde On Blonde",
  year: 1966,
  tracks: [
    ["Rainy Day Women #12 & 35", "4:37"],
    ["Pledging My Time", "3:50"],
    ["Visions of Johanna", "7:34"],
    ["One of Us Must Know (Sooner or Later)", "4:55"],
    ["I Want You", "3:08"],
    ["Stuck Inside of Mobile with the Memphis Blues Again", "7:06"],
    ["Leopard-Skin Pill-Box Hat", "3:58"],
    ["Just Like a Woman", "4:53"],
    ["Most Likely You Go Your Way (And I'll Go Mine)", "3:29"],
    ["Temporary Like Achilles", "5:03"],
    ["Absolutely Sweet Marie", "4:57"],
    ["Fourth Time Around", "4:35"],
    ["Obviously Five Believers", "3:35"],
    ["Sad-Eyed Lady of the Lowlands", "11:16"],
  ],
};

// John Wesley Harding — 1967
const JOHN_WESLEY_HARDING_1967 = {
  artist: "Bob Dylan",
  album: "John Wesley Harding",
  year: 1967,
  tracks: [
    ["John Wesley Harding", "3:00"],
    ["As I Went out One Morning", "2:52"],
    ["I Dreamed I Saw St. Augustine", "3:55"],
    ["All Along the Watchtower", "2:34"],
    ["The Ballad of Frankie Lee and Judas Priest", "5:35"],
    ["Drifter's Escape", "2:48"],
    ["Dear Landlord", "3:18"],
    ["I Am a Lonesome Hobo", "3:24"],
    ["I Pity the Poor Immigrant", "4:16"],
    ["The Wicked Messenger", "2:05"],
    ["Down Along the Cove", "2:25"],
    ["I'll Be Your Baby Tonight", "2:38"],
  ],
};

// Nashville Skyline — 1969
const NASHVILLE_SKYLINE_1969 = {
  artist: "Bob Dylan",
  album: "Nashville Skyline",
  year: 1969,
  tracks: [
    ["Girl from the North Country", "3:44"],
    ["Nashville Skyline Rag", "3:15"],
    ["To Be Alone with You", "2:10"],
    ["I Threw It All Away", "2:26"],
    ["Peggy Day", "2:02"],
    ["Lay, Lady, Lay", "3:21"],
    ["One More Night", "2:25"],
    ["Tell Me That It Isn't True", "2:43"],
    ["Country Pie", "1:39"],
    ["Tonight I'll Be Staying Here with You", "3:23"],
  ],
};

// New Morning — 1970
const NEW_MORNING_1970 = {
  artist: "Bob Dylan",
  album: "New Morning",
  year: 1970,
  tracks: [
    ["If Not for You", "2:43"],
    ["Day of the Locusts", "4:01"],
    ["Time Passes Slowly", "2:38"],
    ["Went to See the Gypsy", "2:53"],
    ["Winterlude", "2:25"],
    ["If Dogs Run Free", "3:42"],
    ["New Morning", "4:02"],
    ["Sign on the Window", "3:43"],
    ["One More Weekend", "3:14"],
    ["The Man in Me", "3:11"],
    ["Three Angels", "2:10"],
    ["Father of Night", "1:29"],
  ],
};

// Self Portrait — 1970
const SELF_PORTRAIT_1970 = {
  artist: "Bob Dylan",
  album: "Self Portrait",
  year: 1970,
  tracks: [
    ["All the Tired Horses", "3:13"],
    ["Alberta #1", "2:57"],
    ["I Forgot More Than You'll Ever Know", "2:25"],
    ["Days of '49", "5:28"],
    ["Early Mornin' Rain", "3:37"],
    ["In Search of Little Sadie", "2:29"],
    ["Let It Be Me", "3:01"],
    ["Little Sadie", "2:01"],
    ["Woogie Boogie", "2:08"],
    ["Belle Isle", "2:33"],
    ["Living the Blues", "2:44"],
    [
      "Like a Rolling Stone - Live at the Isle of Wight, UK - August 1969",
      "5:19",
    ],
    ["Copper Kettle", "3:33"],
    ["Gotta Travel On", "3:07"],
    ["Blue Moon", "2:27"],
    ["The Boxer", "2:46"],
    [
      "(Quinn the Eskimo) The Mighty Quinn - Live at the Isle of Wight, UK - August 1969",
      "2:46",
    ],
    ["Take Me as I Am (Or Let Me Go)", "3:02"],
    ["Take a Message to Mary", "2:45"],
    ["It Hurts Me Too", "3:13"],
    ["Minstrel Boy - Live at the Isle of Wight, UK - August 1969", "3:32"],
    ["She Belongs to Me - Live at the Isle of Wight, UK - August 1969", "2:42"],
    ["Wigwam", "3:08"],
    ["Alberta #2", "3:15"],
  ],
};

/* -------------------------------------------------------------
     Static albums map
  -------------------------------------------------------------- */
export const STATIC_ALBUMS = {
  // 1962–1970 core
  [albumKey("Bob Dylan", 1962)]: BOB_DYLAN_1962,

  [albumKey("The Freewheelin' Bob Dylan", 1963)]: FREEWHEELIN_1963,
  [albumKey("The Freewheelin’ Bob Dylan", 1963)]: FREEWHEELIN_1963, // curly apostrophe alias

  // Another Side (tolerate “Of/of” etc.)
  [albumKey("Another Side Of Bob Dylan", 1964)]: ANOTHER_SIDE_1964,
  [albumKey("Another Side of Bob Dylan", 1964)]: ANOTHER_SIDE_1964,

  [albumKey("The Times They Are A-Changin'", 1964)]: TIMES_1964,

  [albumKey("Highway 61 Revisited", 1965)]: HIGHWAY61_1965,
  [albumKey("Bringing It All Back Home", 1965)]: BRINGING_IT_ALL_BACK_HOME_1965,

  [albumKey("Blonde On Blonde", 1966)]: BLONDE_ON_BLONDE_1966,

  [albumKey("John Wesley Harding", 1967)]: JOHN_WESLEY_HARDING_1967,

  [albumKey("Nashville Skyline", 1969)]: NASHVILLE_SKYLINE_1969,

  [albumKey("New Morning", 1970)]: NEW_MORNING_1970,
  [albumKey("Self Portrait", 1970)]: SELF_PORTRAIT_1970,

  // Dylan (1973)
  [albumKey("Dylan", 1973)]: {
    artist: "Bob Dylan",
    album: "Dylan (1973)",
    year: 1973,
    tracks: [
      ["Lily of the West", "3:47"],
      ["Can't Help Falling in Love", "4:19"],
      ["Sarah Jane", "2:51"],
      ["The Ballad of Ira Hayes", "5:13"],
      ["Mr. Bojangles", "5:32"],
      ["Mary Ann", "2:43"],
      ["Big Yellow Taxi", "2:13"],
      ["A Fool Such As I", "2:43"],
      ["Spanish Is the Loving Tongue", "4:16"],
    ],
  },

  // Pat Garrett & Billy The Kid (Soundtrack...) — 1973 (primary + aliases)
  [albumKey(
    "Pat Garrett & Billy The Kid (Soundtrack From The Motion Picture)",
    1973
  )]: PAT_GARRETT_1973,
  [albumKey(
    "Pat Garrett & Billy the Kid (Soundtrack From The Motion Picture)",
    1973
  )]: PAT_GARRETT_1973,
  [albumKey("Pat Garrett & Billy The Kid", 1973)]: PAT_GARRETT_1973,
  [albumKey("Pat Garrett & Billy the Kid", 1973)]: PAT_GARRETT_1973,

  // 1974 group
  [albumKey("Before The Flood (Live)", 1974)]: BEFORE_THE_FLOOD_1974,
  [albumKey("Before the Flood", 1974)]: BEFORE_THE_FLOOD_1974,
  [albumKey("Planet Waves", 1974)]: PLANET_WAVES_1974,

  // 1975 group
  [albumKey("The Basement Tapes", 1975)]: BASEMENT_TAPES_1975,
  [albumKey("Basement Tapes", 1975)]: BASEMENT_TAPES_1975,
  [albumKey("Blood On The Tracks", 1975)]: BLOOD_ON_THE_TRACKS_1975,
  [albumKey("Blood on the Tracks", 1975)]: BLOOD_ON_THE_TRACKS_1975,

  // 1976–1979
  [albumKey("Hard Rain (Live)", 1976)]: HARD_RAIN_1976,
  [albumKey("Hard Rain", 1976)]: HARD_RAIN_1976,
  [albumKey("Desire", 1976)]: DESIRE_1976,
  [albumKey("Street-Legal", 1978)]: STREET_LEGAL_1978,
  [albumKey("Slow Train Coming", 1979)]: SLOW_TRAIN_COMING_1979,
  [albumKey("Bob Dylan At Budokan (Live)", 1979)]: AT_BUDOKAN_1979,
  [albumKey("Bob Dylan at Budokan", 1979)]: AT_BUDOKAN_1979,

  // 1980s
  [albumKey("Saved", 1980)]: SAVED_1980,
  [albumKey("Shot Of Love", 1981)]: SHOT_OF_LOVE_1981,
  [albumKey("Shot of Love", 1981)]: SHOT_OF_LOVE_1981,
  [albumKey("Infidels", 1983)]: INFIDELS_1983,
  [albumKey("Real Live", 1984)]: REAL_LIVE_1984,
  [albumKey("Real Live", 1985)]: REAL_LIVE_1984, // alias sometimes labeled 1985
  [albumKey("Empire Burlesque", 1985)]: EMPIRE_BURLESQUE_1985,
  [albumKey("Knocked Out Loaded", 1986)]: KNOCKED_OUT_LOADED_1986,
  [albumKey("Down In The Groove", 1988)]: DOWN_IN_THE_GROOVE_1988,
  [albumKey("Down in the Groove", 1988)]: DOWN_IN_THE_GROOVE_1988,
  [albumKey("Dylan & The Dead (Live)", 1989)]: DYLAN_DEAD_1989,
  [albumKey("Dylan & the Dead", 1989)]: DYLAN_DEAD_1989,
  [albumKey("Oh Mercy", 1989)]: OH_MERCY_1989,

  // 1990s
  [albumKey("Under The Red Sky", 1990)]: UNDER_THE_RED_SKY_1990,
  [albumKey(
    "The Bootleg Series Volumes 1-3 (Rare And Unreleased) 1961-1991",
    1991
  )]: BOOTLEG_VOL_1_3_1991,
  [albumKey(
    "The Bootleg Series Volumes 1–3 (Rare And Unreleased) 1961–1991",
    1991
  )]: BOOTLEG_VOL_1_3_1991,
  [albumKey(
    "The Bootleg Series Vol. 1-3 (Rare And Unreleased) 1961-1991",
    1991
  )]: BOOTLEG_VOL_1_3_1991,
  [albumKey(
    "Bootleg Series Volumes 1-3 (Rare And Unreleased) 1961-1991",
    1991
  )]: BOOTLEG_VOL_1_3_1991,
  [albumKey("Good As I Been To You", 1992)]: GOOD_AS_I_BEEN_1992,
  [albumKey("World Gone Wrong", 1993)]: WORLD_GONE_WRONG_1993,
  [albumKey("MTV Unplugged (Live)", 1995)]: MTV_UNPLUGGED_1995,
  [albumKey("MTV Unplugged", 1995)]: MTV_UNPLUGGED_1995,
  [albumKey("Time Out Of Mind", 1997)]: TIME_OUT_OF_MIND_1997,

  // 2000s+
  [albumKey("Love And Theft", 2001)]: LOVE_AND_THEFT_2001,
  [albumKey("Love and Theft", 2001)]: LOVE_AND_THEFT_2001,
  [albumKey("“Love and Theft”", 2001)]: LOVE_AND_THEFT_2001,
  [albumKey('"Love and Theft"', 2001)]: LOVE_AND_THEFT_2001,
  [albumKey("Modern Times", 2006)]: MODERN_TIMES_2006,
  [albumKey("Together Through Life", 2009)]: TOGETHER_THROUGH_LIFE_2009,
  [albumKey("Christmas In The Heart", 2009)]: CHRISTMAS_IN_THE_HEART_2009,
  [albumKey("Tempest", 2012)]: TEMPEST_2012,
  [albumKey("Shadows in the Night", 2015)]: SHADOWS_IN_THE_NIGHT_2015,
  [albumKey("Fallen Angels", 2016)]: FALLEN_ANGELS_2016,
  [albumKey("Triplicate", 2017)]: TRIPLICATE_2017,
  [albumKey(
    "The Rolling Thunder Revue: The 1975 Live Recordings (Sampler)",
    2019
  )]: ROLLING_THUNDER_SAMPLER_2019,
  [albumKey("Rolling Thunder Revue: The 1975 Live Recordings (Sampler)", 2019)]:
    ROLLING_THUNDER_SAMPLER_2019,
  [albumKey("Rough and Rowdy Ways", 2020)]: ROUGH_AND_ROWDY_2020,
  [albumKey("Shadow Kingdom", 2023)]: SHADOW_KINGDOM_2023,
  [albumKey("The Complete Budokan 1978 (Live)", 2023)]:
    COMPLETE_BUDOKAN_1978_2023,
  [albumKey("Complete Budokan 1978 (Live)", 2023)]: COMPLETE_BUDOKAN_1978_2023,
  [albumKey("The 1974 Live Recordings Sampler", 2024)]: LIVE_1974_SAMPLER_2024,
};

/* -------------------------------------------------------------
     Helper to fetch a static album by (title, year)
  -------------------------------------------------------------- */
export function getAlbumStatic(title, year) {
  return STATIC_ALBUMS[albumKey(title, year)] || null;
}
